import { render, staticRenderFns } from "./OrderSidebarInformations.vue?vue&type=template&id=c6e3c3a2&"
import script from "./OrderSidebarInformations.vue?vue&type=script&lang=js&"
export * from "./OrderSidebarInformations.vue?vue&type=script&lang=js&"
import style0 from "./OrderSidebarInformations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports